// noinspection JSCheckFunctionSignatures

import {Children, cloneElement, useEffect} from "react";
import {createPortal} from "react-dom";
import {TextButton} from "./index";

const settingMenuWidth = 200;

export const SettingsMenuItem = ({label, isActive, onClick}) => <p>
	<TextButton className={isActive ? 'active' : null} onClick={(e) => onClick(e)}>{label}</TextButton>
</p>

const SettingMenu = ({
											 menuRef, isShow, children, onClose
										 }) => {
	useEffect(() => {
		const onHandleClose = () => {
			if (isShow && onClose) {
				setTimeout(() => onClose(), 0);
			}
		};

		window.addEventListener('click', onHandleClose);

		return () => {
			window.removeEventListener('click', onHandleClose);
		};
	}, [isShow, onClose]);

	if (!isShow) {
		return null;
	}

	const style = {
		top: 0,
		left: 0,
	};

	if (menuRef) {
		const fullWidth = document.body.clientWidth;
		const rect = menuRef.getBoundingClientRect();
		style.left = rect.left + settingMenuWidth - 5 > fullWidth ? fullWidth - settingMenuWidth - 5 : rect.left - 120;
		style.top = rect.top + rect.height;
	}

	return createPortal(
		<div className={"setting_menu"} style={style} onClick={(e) => e.stopPropagation()}>{Children.map(children, (child) => child.props.notShow? "" : cloneElement(child) )}</div>,
		document.body
	)
}

export default SettingMenu;
